export default __webpack_public_path__ + "static/media/katalog-pl.2da75cd0.png";